module.exports = __webpack_public_path__ + "img/c3.b1636798.jpg";